import type { ChipProps } from "@mui/material";
import { TaskStatusId } from "web_myplann/Tasks/Types/TaskStatusId";

const CHIP_COLOR_BY_STATUS: Record<TaskStatusId, ChipProps["color"]> = {
	[TaskStatusId.New]: "default",
	[TaskStatusId.InProgress]: "info",
	[TaskStatusId.Waiting]: "warning",
	[TaskStatusId.Done]: "success",
};

export const getTaskStatusChipColor = (
	statusId: number | null | undefined,
): ChipProps["color"] =>
	(statusId == null
		? undefined
		: CHIP_COLOR_BY_STATUS[statusId as TaskStatusId]) ?? "default";
